// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__mI806","constructorGuy":"Banner_constructorGuy__fEqWZ","bannerText":"Banner_bannerText__GJ-ij","bannerShape":"Banner_bannerShape__Ues1A"};